var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[(_vm.app_loaded)?_c(_vm.layout,{tag:"component",attrs:{"sidebar":_vm.sidebar}},[_c('router-view')],1):_vm._e(),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }